module.exports = __webpack_public_path__ + "images/arr-up-blue.svg?a2dd62022e652232aaa3e67701c7877a";